export const TICKET_TYPES = {
  SUPPORT_TICKET: "Support Tickets",
  REJECTION_TICKET: "Rejection Tickets",
  DELIVERY_TICKET: "Delivery Tickets",
};
